/**
 * Returns the csrf-token meta tag's content value or undefined if this meta tag is not present.
 * @returns the string value of the csrf-token meta tag's content attribute or undefined if this meta tag is not present.
 */
export function metaCsrfToken(): string | undefined {
  return (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content;
}
